import { put, call, takeLatest } from 'redux-saga/effects';
import Cookies from 'universal-cookie';
import { USER_LOGOUT } from './types';
import { FETCH_ERRORS } from '../error/types';
import { removeToken } from '../../network/auth';

const cookies = new Cookies();

function* removeTokenDB() {
  try {
    yield call(removeToken);
    localStorage.clear();
    cookies.remove('uuid_session');
    window.location.replace('/');
  } catch (err) {
    localStorage.clear();
    cookies.remove('uuid_session');
    window.location.replace('/');
    yield put({
      type: FETCH_ERRORS, payload: {
        status: err.response.status || 500,
      }
    });
  }
};

function* watchRemoveToken() {
  yield takeLatest(USER_LOGOUT, removeTokenDB);
};

export default [
  watchRemoveToken(),
];